import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlTimeProps extends ControlTemplateProps {
    
}

export const ControlTime: React.FC<ControlTimeProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="time" {...ComponentProps(props)} style={{ ...styles.time ?? styles.date ?? styles.text ?? styles.input, ...props.style }} />        
    );
};